import { render, staticRenderFns } from "./ISave.vue?vue&type=template&id=3f1bff8e&"
import script from "./ISave.vue?vue&type=script&lang=ts&"
export * from "./ISave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports